function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled from 'styled-components';
import { GEL_SPACING, GEL_SPACING_DBL } from '@bbc/gel-foundations/spacings';
import { grid } from '@bbc/psammead-styles/detection';
import Grid from '@bbc/psammead-grid';
import { arrayOf, number, oneOf, shape, string } from 'prop-types';
import { scriptPropType } from '@bbc/gel-foundations/prop-types';
import ProgramCard from './ProgramCard';
import StartTime from './StartTime';
var StartTimeWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "StartTimeWrapper",
  componentId: "sc-1q74lji-0"
})(["padding-bottom:", ";"], GEL_SPACING); // Reset default of <ul> style

var StyledGrid = /*#__PURE__*/styled(Grid).attrs({
  role: 'list'
}).withConfig({
  displayName: "StyledGrid",
  componentId: "sc-1q74lji-1"
})(["padding:0;margin:0;"]); // Using flex-box on browsers that do not support grid will break grid fallback defined in psammead-grid

var StyledFlexGrid = /*#__PURE__*/styled(Grid).attrs(function (_ref) {
  var state = _ref.state;
  return {
    role: 'listitem',
    'data-e2e': state
  };
}).withConfig({
  displayName: "StyledFlexGrid",
  componentId: "sc-1q74lji-2"
})(["@supports (", "){display:flex;flex-direction:column;}position:relative;padding-bottom:", ";"], grid, GEL_SPACING_DBL);

var renderSchedule = function renderSchedule(_ref2) {
  var service = _ref2.service,
      script = _ref2.script,
      dir = _ref2.dir,
      timezone = _ref2.timezone,
      locale = _ref2.locale,
      program = _ref2.program,
      nextLabel = _ref2.nextLabel,
      liveLabel = _ref2.liveLabel,
      durationLabel = _ref2.durationLabel;
  var state = program.state,
      startTime = program.startTime,
      link = program.link,
      brandTitle = program.brandTitle,
      summary = program.summary,
      duration = program.duration;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StartTimeWrapper, null, /*#__PURE__*/React.createElement(StartTime, {
    timestamp: startTime,
    service: service,
    script: script,
    locale: locale,
    timezone: timezone,
    dir: dir
  })), /*#__PURE__*/React.createElement(ProgramCard, {
    duration: duration,
    summary: summary,
    durationLabel: durationLabel,
    service: service,
    script: script,
    dir: dir,
    brandTitle: brandTitle,
    startTime: startTime,
    state: state,
    link: link,
    nextLabel: nextLabel,
    liveLabel: liveLabel,
    timezone: timezone,
    locale: locale
  }));
};

var schedulesGridProps = {
  enableGelGutters: true,
  columns: {
    group0: 4,
    group1: 4,
    group2: 6,
    group3: 6,
    group4: 8,
    group5: 8
  },
  margins: {
    group0: true,
    group1: true,
    group2: true
  }
};
var programGridProps = {
  item: true,
  columns: {
    group0: 4,
    group1: 4,
    group2: 6,
    group3: 3,
    group4: 2,
    group5: 2
  }
};
/*
Currently, we are passing a list of schedules to this component and mapping
through the list to render a star-time and program-card, inside a gird.
We intend to move the map functionality out of psammead in a future iteration.
*/

var RadioSchedule = function RadioSchedule(_ref3) {
  var schedules = _ref3.schedules,
      dir = _ref3.dir,
      props = _objectWithoutProperties(_ref3, ["schedules", "dir"]);

  return /*#__PURE__*/React.createElement(StyledGrid, _extends({
    forwardedAs: "ul",
    dir: dir
  }, schedulesGridProps), schedules.map(function (_ref4) {
    var id = _ref4.id,
        program = _objectWithoutProperties(_ref4, ["id"]);

    return /*#__PURE__*/React.createElement(StyledFlexGrid, _extends({
      dir: dir,
      parentColumns: schedulesGridProps.columns,
      parentEnableGelGutters: true
    }, programGridProps, {
      key: id,
      forwardedAs: "li",
      state: program.state
    }), renderSchedule(_objectSpread(_objectSpread({}, props), {}, {
      dir: dir,
      program: program
    })));
  }));
};

var programPropTypes = shape({
  state: string.isRequired,
  startTime: number.isRequired,
  link: string.isRequired,
  brandTitle: string.isRequired,
  summary: string,
  duration: string.isRequired
});
var sharedProps = {
  timezone: string,
  locale: string,
  service: string.isRequired,
  script: shape(scriptPropType).isRequired,
  nextLabel: string.isRequired,
  liveLabel: string.isRequired,
  durationLabel: string.isRequired,
  dir: oneOf(['rtl', 'ltr'])
};
renderSchedule.propTypes = _objectSpread({
  program: programPropTypes.isRequired
}, sharedProps);
RadioSchedule.propTypes = _objectSpread({
  schedules: arrayOf(programPropTypes).isRequired
}, sharedProps);
/* eslint-disable react/default-props-match-prop-types */

RadioSchedule.defaultProps = {
  dir: 'ltr',
  timezone: 'Europe/London',
  locale: 'en-gb'
};
export default RadioSchedule;